import { render } from "./RecuperarContraseña.vue?vue&type=template&id=b3814b00&scoped=true"
import script from "./RecuperarContraseña.vue?vue&type=script&lang=js"
export * from "./RecuperarContraseña.vue?vue&type=script&lang=js"

import "./RecuperarContraseña.vue?vue&type=style&index=0&id=b3814b00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3814b00"]])

export default __exports__